import React from 'react'
import styled from 'styled-components';
import {device} from '../../MainContents/Style/StyleDevice'

const TableWhitespace = styled.div`
    padding:30px 0px 30px;
    margin:30px 0px 30px;
`;
const TableMarginWid = styled.table`
    width: 90%;
    margin: auto;
    table-layout: fixed;
    word-wrap: break-word;
    display: table;
    @media ${device.laptop}{
    display: block !important;
    }
`;
const Comment = styled.div`
    width: 90%;
    margin: auto;
`
const Margin = styled.div`
 margin: 30px 0px 30px;
`;
const WinterTable = (props) => {
      return (
           <Margin>
                  <TableWhitespace>
                                <TableMarginWid className="table table-bordered text-center table-responsive table-scope">
                                <thead>
                                    <tr>
                                        <th>学年</th>
                                        <th>日程</th>
                                        <th>時間</th>
                                        <th>科目</th>
                                        <th>講座料(税込)</th>
                                    </tr>
                                </thead>  
                                <tbody>
                                    <tr>
                                        <td>小２</td>
                                        <td>12/26～29</td>
                                        <td>10:00～11:35</td>
                                        <td>算　国</td>
                                        <td>8,800円</td>
                                    </tr>
                                    <tr>
                                        <td>小３</td>
                                        <td>12/26～29、1/6～7</td>
                                        <td>13:00～14:35</td>
                                        <td>算　国</td>
                                        <td>13,200円</td>
                                    </tr>
                                    <tr>
                                        <td>小４</td>
                                        <td>12/25～29、1/6～7</td>
                                        <td>13:00～17:05</td>
                                        <td>算　国　理　社</td>
                                        <td>15,400円</td>
                                    </tr>
                                    <tr>
                                        <td rowSpan='2' className="align-middle">小５</td>
                                        <td>12/25～29、1/6～7</td>
                                        <td>13:00～17:55</td>
                                        <td>算　国　理　社</td>
                                        <td>29,700円</td>
                                    </tr>
                                    <tr>
                                        <td>1/4～5</td>
                                        <td>13:00～17:00</td>
                                        <td>単科集中特訓</td>
                                        <td>11,000円</td>
                                    </tr>
                                </tbody>
                                
                            </TableMarginWid>
                            <Comment>
                            <p className="font-weight-bold">※小５生の単科集中特訓授業(1/4～5)は講座受講生のオプション料金となっています。</p>
                            <p className="font-weight-bold">※小６生の冬期講座の募集は行っておりません。</p>
                            </Comment>
                </TableWhitespace>
           </Margin>
      );
};
  

export default WinterTable;